<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-start justify-content-between mb-3">
    <div>
      <p class="fs-normal fw-800 color-gray-950 mb-0">{{'students.videos.assign_title'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">{{'students.videos.assign_desc'|translate}}</p>
    </div>

    <a class="clickable color-gray-400 ms-2" (click)="modal.dismiss()"
       [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <!-- What is being assigned -->
  <div class="content-summary d-flex align-items-center gap-3 p-2 mb-3">
    <div class="summary-poster">
      <app-content-poster
        [video]="item.video" [liveStream]="item.liveStream" [showProgress]="false"></app-content-poster>
    </div>

    <div class="overflow-hidden">
      <app-content-type-badge [type]="item.type"></app-content-type-badge>
      <p class="fs-small fw-800 color-gray-950 mb-0 mt-1">{{item.title}}</p>
    </div>
  </div>

  <p class="fs-xsmall fw-400 color-gray-400 mb-3" *ngIf="!item.canView">
    <i class="bi bi-lock me-1"></i>{{'students.videos.locked_warning'|translate}}
  </p>

  <form [formGroup]="fg" (ngSubmit)="onSubmit()">
    <p class="fs-small fw-800 color-gray-500 mb-2">{{'students.videos.task_content'|translate|uppercase}}</p>

    <textarea
      class="task-textarea w-100" formControlName="content"
      [placeholder]="'students.videos.task_placeholder'|translate"></textarea>
    <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('content')?.errors">
      <p>{{'errors.required'|translate}}</p>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <app-gray-button
        type="submit" color="primary" [fullWidth]="false" padding="px-3 py-2 gap-1" [weight]="800"
        customClass="d-flex align-items-center fs-small border-8" preIcon="plus"
        [isLoading]="isSaving" [disabled]="isSaving"
        [text]="'students.videos.assign_submit'|translate"></app-gray-button>
    </div>
  </form>

</div>
